module.exports = __webpack_public_path__ + "img/1568800587.c99eda56.jpg";